module.exports = __webpack_public_path__ + "img/partner.bcc27355.png";